"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HubOrgClient = void 0;
const BaseHubClient_1 = require("./BaseHubClient");
const path = `/orgs/`;
class HubOrgClient extends BaseHubClient_1.BaseHubClient {
    async getOrganization(orgKey) {
        return await this.request('GET', `${path}${orgKey}`, undefined, undefined);
    }
    async searchOrganizations(search) {
        return await this.request('GET', `${path}search`, { search: search }, undefined);
    }
    async getAppConfigs() {
        return await this.request('GET', `${path}config`, undefined, undefined);
    }
}
exports.HubOrgClient = HubOrgClient;
